// Inspired by: https://github.com/excid3/tailwindcss-stimulus-components/blob/master/src/popover.js

import { Controller } from "@hotwired/stimulus";

export default class UIToggleController extends Controller {
  connect() {}

  // A label with `for` forwards its click to the button, which then bubbles back here -- so a click on
  // the label arrived twice and toggled twice, landing back where it started while dispatching two
  // change events. A form that submits on change turns those into racing requests with opposite values.
  toggle(event) {
    if (event?.target?.closest("label")) return;

    const button = this.element.querySelector("button");
    // A click on the wrapper beside a disabled button still lands here.
    if (button.disabled) return;

    const span = this.element.querySelector("span");
    const input = this.element.querySelector("input[type='hidden']");

    if (this.element.dataset.state == "checked") {
      input.value = "false";
      button.dataset.state = "unchecked";
      button.setAttribute("aria-checked", "false");
      span.dataset.state = "unchecked";
      this.element.dataset.state = "unchecked";
    } else {
      input.value = "true";
      button.dataset.state = "checked";
      button.setAttribute("aria-checked", "true");
      span.dataset.state = "checked";
      this.element.dataset.state = "checked";
    }
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
